import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { formatRp, formatDateID } from "@/lib/constants";
import ReservationDetail from "@/components/ReservationDetail";
import { Wallet, LockSimple, LockOpen, Clock } from "@phosphor-icons/react";

const TABS = [["", "Semua"], ["pending", "Belum Final"], ["final", "Sudah Final"]];

export default function KasirShift() {
  const [items, setItems] = useState(null);
  const [tab, setTab] = useState("");
  const [denied, setDenied] = useState(false);
  const [detail, setDetail] = useState(null);

  const load = useCallback(() => {
    api.get("/billing/queue")
      .then((r) => {
        const items = r.data.items || [];
        setItems(items); setDenied(false);
        setDetail((d) => (d ? (items.find((x) => x.id === d.id) || d) : d));
      })
      .catch((e) => { if (e?.response?.status === 403) setDenied(true); setItems([]); });
  }, []);
  useEffect(() => { load(); }, [load]);

  if (denied) {
    return (
      <div data-testid="kasir-denied" className="rounded-2xl border border-rose-100 bg-white p-8 text-center text-sm text-slate-500">
        Akses ditolak. Halaman ini khusus Admin / Super Admin / petugas berpermission Kasir Shift.
      </div>
    );
  }

  const rows = (items || []).filter((i) => !tab || (i.bill_status || "pending") === tab);
  const nPending = (items || []).filter((i) => (i.bill_status || "pending") === "pending").length;

  return (
    <div className="animate-fade-up space-y-5">
      <div className="flex items-center gap-2">
        <Wallet size={26} weight="duotone" className="text-[#7C4DE0]" />
        <div>
          <h1 className="font-heading text-3xl font-extrabold text-slate-800">Kasir Shift</h1>
          <p className="text-xs text-slate-500">Tagihan layanan Berdasarkan Rincian Pelayanan · {nPending} belum final</p>
        </div>
      </div>

      <div className="flex gap-2">
        {TABS.map(([k, label]) => (
          <button key={k} data-testid={`kasir-tab-${k || "all"}`} onClick={() => setTab(k)} className={`rounded-full px-3 py-1.5 text-xs font-semibold ${tab === k ? "bg-[#6A38C7] text-white" : "bg-rose-50 text-[#6A38C7] hover:bg-[#EEE6FF]"}`}>{label}</button>
        ))}
      </div>

      {items === null ? (
        <div className="flex justify-center py-16"><div className="h-8 w-8 animate-spin rounded-full border-4 border-rose-200 border-t-rose-500" /></div>
      ) : rows.length === 0 ? (
        <div className="rounded-2xl border border-rose-100/70 bg-white p-8 text-center text-sm text-slate-400" data-testid="kasir-empty">Tidak ada tagihan pada filter ini.</div>
      ) : (
        <div className="space-y-2">
          {rows.map((i) => (
            <button key={i.id} data-testid={`kasir-row-${i.id}`} onClick={() => setDetail(i)} className="w-full rounded-2xl border border-rose-100/70 bg-white p-4 text-left shadow-sm transition-colors hover:border-indigo-200 hover:bg-indigo-50/30">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <p className="truncate font-heading text-sm font-extrabold text-slate-800">{i.nama_lengkap} <span className="ml-1 font-mono text-[10px] font-normal text-slate-400">{i.kode}</span></p>
                  <p className="mt-0.5 truncate text-xs text-slate-500">{i.jenis_layanan} · {i.petugas_nama}</p>
                  <p className="mt-0.5 flex items-center gap-1 text-[11px] text-slate-400"><Clock size={11} /> {formatDateID(i.tanggal_kunjungan)}{i.jam_kunjungan ? ` · ${i.jam_kunjungan}` : ""}</p>
                </div>
                <span data-testid={`kasir-bill-status-${i.id}`} className={`shrink-0 rounded-full border px-2 py-0.5 text-[10px] font-bold ${i.bill_status === "final" ? "border-emerald-200 bg-emerald-100 text-emerald-700" : "border-indigo-200 bg-indigo-100 text-indigo-700"}`}>
                  {i.bill_status === "final" ? <span className="inline-flex items-center gap-1"><LockSimple size={10} weight="fill" /> FINAL</span> : <span className="inline-flex items-center gap-1"><LockOpen size={10} /> BELUM FINAL</span>}
                </span>
              </div>
              <div className="mt-2 grid grid-cols-3 gap-2 border-t border-rose-50 pt-2 text-[11px]">
                <div><p className="text-slate-400">Total Tagihan</p><p className="font-bold text-slate-700" data-testid={`kasir-total-${i.id}`}>{formatRp(i.total_tagihan)}</p></div>
                <div><p className="text-slate-400">Diterima</p><p className="font-bold text-emerald-700">{formatRp(i.total_dibayar)}</p></div>
                <div><p className="text-slate-400">Sisa</p><p className="font-bold text-rose-600">{formatRp(i.sisa_tagihan)}</p></div>
              </div>
            </button>
          ))}
        </div>
      )}

      <ReservationDetail reservation={detail} open={!!detail} onClose={() => setDetail(null)} onChanged={load} />
    </div>
  );
}
